import DirectusCombobox from "../combobox";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";

export default function CompanyCombobox({
  filter,
  hideLabel,
  className,
  ...props
}) {
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="companies"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          sort={["name"]}
          placeholder="Select Company"
          {...props}
        />
      </div>
    );
  }
  return (
    <FilterWrapper label="Company" className={className}>
      <DirectusCombobox
        client={client}
        collection="companies"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        sort={["name"]}
        {...props}
      />
    </FilterWrapper>
  );
}
